import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { NaukriCandidates } from '@/features/naukri-candidates'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  filter: z.string().optional().catch(''),
  functionalArea: z.string().optional().catch(undefined),
  extracted: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/naukri-candidates/')({
  validateSearch: searchSchema,
  component: NaukriCandidates,
})
